import { axios } from 'lib/axios';

export const smsOTPSetup = async (data) => {
  return await axios.post('/user/sms/setup', data);
};
